import NavSideControl from "../controls/navigation/nav-side-control";
import TopViewButton from "../button/top-view-button";
import SimBottomPanel from "../controls/simulation/sim-bottom-panel";
import { useEffect, useState } from "react";
import { useAppStore } from "@/store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useCrimeSceneStore } from "src/store/crimeSceneStore";
import AIAgentPanel from "../controls/ai-agent-panel";
import { useNavigationStore } from "@/store/navigationStore";
import { useTranslation } from "react-i18next";
import SimHeader from "../controls/simulation/sim-header";
import SimMCPanel from "../controls/simulation/sim-mc-panel";
import Dialog from "../dialog/dialog";
import { CRIME_SCENE_OBJECTIVES } from "@/const/crimeSceneConst";
import { SceneObjectives } from "@/types/crime";
import ShareDialog from "../dialog/share-dialog";
import { useLanguageStore } from "@/store/languageStore";
import useMessagePlayer from "@/hooks/useMessagePlayer";

export default function CrimeSceneLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();

  const IncidentOccurence = () => {
    const isShownIncidentOccurence = useCrimeSceneStore(
      (state) => state.isShownIncidentOccurence
    );

    return (
      <div
        className={`transition-all transition-transform duration-300 ease-in-out
    ${
      isShownIncidentOccurence
        ? "translate-y-0 h-[100dvh]"
        : "translate-y-full h-[85dvh]"
    }
    fixed left-0 right-0 bottom-0`}
        style={{ zIndex: 54 }}
      >
        <AIAgentPanel />
      </div>
    );
  };

  const Panel = () => {
    const isFinishedAllMc = useCrimeSceneStore(
      (state) => state.isFinishedAllMc
    );
    const userQuery = useNavigationStore((state) => state.userQuery);
    const setUserQuery = useNavigationStore((state) => state.setUserQuery);
    const showMCPanel = useCrimeSceneStore((state) => state.showMCPanel);
    const setShowMCPanel = useCrimeSceneStore((state) => state.setShowMCPanel);
    const showObjective = useCrimeSceneStore((state) => state.showObjective);
    const setShowObjective = useCrimeSceneStore(
      (state) => state.setShowObjective
    );
    const showSceneDialog = useCrimeSceneStore(
      (state) => state.showSceneDialog
    );
    const setShowSceneDialog = useCrimeSceneStore(
      (state) => state.setShowSceneDialog
    );
    const chatType = useAppStore((state) => state.chatType);
    const setChatType = useAppStore((state) => state.setChatType);

    const startAutoPlayDelay = useCrimeSceneStore(
      (state) => state.startAutoPlayDelay
    );

    const [currentObjective, setCurrentObjective] =
      useState<SceneObjectives | null>(null);

    const sceneIndex = useCrimeSceneStore((state) => state.sceneIndex);
    const setSceneIndex = useCrimeSceneStore((state) => state.setSceneIndex);
    const startPlayMessages = useCrimeSceneStore(
      (state) => state.startPlayMessages
    );
    const hasUserInteraction = useAppStore((state) => state.hasUserInteraction);
    const setHasUserInteraction = useAppStore(
      (state) => state.setHasUserInteraction
    );
    const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
    const { readText } = useMessagePlayer();
    const { t } = useTranslation();
    useEffect(() => {
      if (chatType != CHAT_TYPE.SIMULATION) {
        setChatType(CHAT_TYPE.SIMULATION);
        if (!userQuery) {
          setUserQuery(t("example_simulation"));
        }
      }
    }, [chatType]);

    useEffect(() => {
      const sceneIndexObjectives = CRIME_SCENE_OBJECTIVES.filter(
        (c) => c.scene === sceneIndex
      );
      console.log("useEffect sceneIndex", sceneIndex);
      if (sceneIndexObjectives.length > 0) {
        if (
          !currentObjective ||
          (currentObjective && currentObjective.scene !== sceneIndex)
        ) {
          setCurrentObjective(sceneIndexObjectives[0]);
          setShowSceneDialog(true);
        }
      }
    }, [sceneIndex]);

    return (
      <>
        {showMCPanel && <SimMCPanel currentScene={sceneIndex} />}

        {showSceneDialog && currentObjective && (
          <Dialog
            image="/assets/icon_clapboard.png"
            title={`${t("scene")} ${currentObjective.scene + 1}`}
            desc={currentObjective.title}
            spacing={8}
            onClick={() => {
              if (!hasUserInteraction) {
                readText("", voiceLanguage, false);
                setHasUserInteraction(true);
              }
              setShowSceneDialog(false);
              startAutoPlayDelay(0);
              startPlayMessages();
            }}
          />
        )}

        {showObjective && currentObjective && (
          <Dialog
            title={t("objective")}
            desc={currentObjective.objectives}
            onClick={() => {
              if (!isFinishedAllMc) {
                setShowObjective(false);
                setShowMCPanel(true);
              } else {
                if (sceneIndex < CRIME_SCENE_OBJECTIVES.length - 1) {
                  setShowObjective(false);
                  setSceneIndex(sceneIndex + 1);
                } else {
                  setShowObjective(false);
                  setShowMCPanel(true);
                }
              }
            }}
          />
        )}

        {/* {isShareOpen && <ShareDialog />} */}
        <Share />
      </>
    );
  };

  const Share = () => {
    const isShareOpen = useAppStore((state) => state.isShareOpen);
    return isShareOpen ? <ShareDialog /> : <></>;
  };

  return (
    <div className="fullscreen_div">
      {children}
      <SimHeader />
      <div className="absolute bottom-0 left-0 right-0">
        <SimBottomPanel />
      </div>
      <div className="absolute bottom-[184px] md:bottom-20 right-0">
        <NavSideControl />
      </div>
      <div className="absolute bottom-[184px] md:bottom-20 left-0 m-6 mb-[20px] md:mb-[35px]">
        <TopViewButton />
      </div>
      <IncidentOccurence />

      <Panel />
    </div>
  );
}
